export default  require('@os-store/booking/order')



// WEBPACK FOOTER //
// ./store/booking/order.js